import { Button } from "@renderbus/ui";
import SearchIcon from "@/assets/icons/invoice/search";
import styled from "styled-components";

export function SearchBtn({ onClick }: { onClick?: () => void }) {
  return (
    <SearchButton onClick={onClick} size={"middle"} icon={<SearchIcon />} />
  );
}

const SearchButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #333336;
  border-color: #333336;
  &:hover {
    background: #333336;
    border-color: #5c5c5e;
  }
  &:active,
  &:focus {
    background: #5c5c5e;
    border-color: #5c5c5e;
  }
`;
